import { NavigationContainerRefWithCurrent } from '@react-navigation/native'
import { useTheme } from 'contexts'
import React from 'react'
import { StyleSheet } from 'react-native'

import { BottomSheetNav } from 'widgets/BottomSheetNav'
import { Box } from 'widgets/Box'
import { Button } from 'widgets/Button'

import { useCurrentUser } from 'hooks/useCurrentUser'

import { links } from 'utils/constants'
import { getUpspaceLink } from 'utils/links/links'
import { handleShareAction } from 'utils/sharing'

import { useCoachOnboardingModal } from 'contexts/CoachOnboardingModalContext'

import { CoachOnboardingPrompt } from '../subcomponents/CoachOnboardingPrompt'
import { ImageUploadButton } from '../subcomponents/ImageUploadButton'

export const UpspaceNextPage = ({
  drawerNavigationRef,
}: {
  drawerNavigationRef: NavigationContainerRefWithCurrent<ReactNavigation.RootParamList>
}) => {
  const theme = useTheme()
  const coachOnboardingModalRef = useCoachOnboardingModal()
  const { data: currentUser } = useCurrentUser()

  const computedStyles = StyleSheet.create({
    button: {
      backgroundColor: theme.colors.v2black,
      borderRadius: 10,
      marginTop: 27,
    },
    borderButton: {
      borderColor: theme.colors.v2black,
      borderWidth: 2,
      borderRadius: 10,
      marginTop: 10,
    },
  })

  const handleWorkoutPress = () => {
    coachOnboardingModalRef?.current?.dismiss()
    drawerNavigationRef?.current?.navigate(links.CREATE_WORKOUT_PAGE)
  }

  const handleInvitePress = async () => {
    coachOnboardingModalRef?.current?.dismiss()
    const url = getUpspaceLink(currentUser?.username as string)
    await handleShareAction(
      url,
      'Join my group on Upspace!',
      drawerNavigationRef,
      links.SHARE_GROUP_PAGE,
      currentUser?.username,
    )
  }

  const handleSharePress = async () => {
    coachOnboardingModalRef?.current?.dismiss()
    drawerNavigationRef?.current?.navigate(links.CREATE_POST_PAGE)
  }

  return (
    <Box testID='UpspaceNextPage' flexDirection='column' backgroundColor='v2primary' flex={1}>
      <BottomSheetNav bottomSheetRef={coachOnboardingModalRef} withBack withDone />
      <Box testID='CoachOnboardingContent' padding='lg'>
        <CoachOnboardingPrompt
          title={`Let's gooo! Your Group is live.\nWhat would you like to do first?`}
        />
        <Box testID='CoachOnboardingInput'>
          <ImageUploadButton />
          <Button
            type='v2black'
            style={computedStyles.button}
            title='Create a Workout'
            titleColor='white'
            onPress={handleWorkoutPress}
          />
          <Button
            type='v2primary'
            style={computedStyles.borderButton}
            title='Invite a Few Friends'
            titleColor='white'
            onPress={handleInvitePress}
          />
          <Button
            type='v2primary'
            style={computedStyles.borderButton}
            title='Share a Post'
            titleColor='white'
            onPress={handleSharePress}
          />
        </Box>
      </Box>
    </Box>
  )
}
